import { PropsWithChildren } from 'react'
import { AuthContextProvider } from './AuthContext'
export * from './AuthContext'

export const ContextProviders = ({children}: PropsWithChildren) => {
    return (
        <AuthContextProvider>
            {children}
        </AuthContextProvider>
    )
}